<div class="session_wrapper_2 signup-2 login-2 main-login_v2">
  <div class="session_wrapper_2-left_container">
    <div class="behamics-logo">
      <svg
        viewBox="0 0 161 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        *ngIf="!isWhiteLabel"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.8339 7.95235C15.5807 7.95235 19.4969 12.3167 19.4969 17.9655C19.4969 23.6143 15.5846 27.9787 10.8339 27.9787C9.81249 28.0297 8.79296 27.8474 7.85515 27.4461C6.91735 27.0448 6.08675 26.4354 5.42841 25.6656V27.4474H0V0.895131C1.48589 0.943557 2.89166 1.56942 3.90921 2.63555C4.92675 3.70169 5.47306 5.12112 5.42841 6.58275V10.2605C6.08564 9.49102 6.91513 8.88175 7.85186 8.48043C8.78859 8.07911 9.80709 7.89664 10.8275 7.94733L10.8339 7.95235ZM9.74846 22.5918C10.3507 22.5991 10.9477 22.4813 11.5005 22.2462C12.0533 22.011 12.5494 21.6638 12.9564 21.2271C13.3635 20.7905 13.6722 20.2743 13.8625 19.7123C14.0528 19.1502 14.1204 18.555 14.0609 17.9655C14.1206 17.3759 14.0532 16.7806 13.863 16.2184C13.6727 15.6562 13.364 15.1398 12.957 14.7031C12.5499 14.2663 12.0537 13.9189 11.5008 13.6837C10.948 13.4485 10.3508 13.3307 9.74846 13.338C9.14547 13.3296 8.54748 13.4466 7.99368 13.6814C7.43987 13.9161 6.94274 14.2633 6.53487 14.7002C6.127 15.1371 5.81758 15.6539 5.62691 16.2166C5.43623 16.7793 5.36859 17.3753 5.42841 17.9655C5.36878 18.5556 5.43656 19.1515 5.62733 19.7141C5.81809 20.2766 6.12753 20.7932 6.53539 21.23C6.94324 21.6667 7.4403 22.0138 7.99401 22.2485C8.54772 22.4832 9.14559 22.6002 9.74846 22.5918ZM27.4682 20.2411C27.7791 21.1032 28.3789 21.8358 29.1691 22.3183C29.9592 22.8008 30.8928 23.0047 31.8163 22.8963C32.4668 22.9125 33.1133 22.7924 33.7129 22.544C34.3126 22.2955 34.8516 21.9244 35.2942 21.4553L39.6423 24.0767C38.7784 25.341 37.5976 26.3648 36.214 27.0492C34.8304 27.7336 33.2907 28.0555 31.7437 27.9837C25.5521 27.9837 21.706 23.6193 21.706 17.9705C21.706 12.3218 25.6158 7.95736 31.3449 7.95736C36.6345 7.95736 40.5481 12.2428 40.5481 17.9705C40.5533 18.7324 40.482 19.493 40.3354 20.2411H27.4682ZM53.8395 8.45607C57.5009 8.45607 60.6158 11.1852 60.6158 16.3065V27.9524C59.1294 27.9056 57.7226 27.2809 56.7038 26.2154C55.685 25.15 55.1374 23.7306 55.181 22.2685V17.1435C55.2417 16.7061 55.2048 16.2608 55.0729 15.8388C54.9409 15.4168 54.7172 15.0281 54.4171 14.6997C54.1171 14.3713 53.7479 14.1111 53.3354 13.9372C52.9228 13.7633 52.4766 13.6798 52.0279 13.6926C50.0354 13.6926 48.6582 14.9106 48.6582 17.5996V27.9524C47.1719 27.9056 45.7651 27.2809 44.7463 26.2154C43.7275 25.15 43.1799 23.7306 43.2235 22.2685V1.40512C44.7097 1.45226 46.1163 2.077 47.135 3.14242C48.1537 4.20784 48.7015 5.62704 48.6582 7.08899V10.7667C49.2624 9.99252 50.0512 9.37668 50.9549 8.97367C51.8586 8.57066 52.8493 8.39288 53.8395 8.45607ZM107.266 8.48364C111.433 8.48364 114.146 11.5937 114.146 16.334V27.9799C112.659 27.9331 111.253 27.3085 110.234 26.243C109.215 25.1775 108.667 23.7581 108.711 22.2961V16.8315C108.711 14.9356 107.841 13.7214 106.102 13.7214C104.29 13.7214 103.276 15.0484 103.276 17.2864V27.9799C101.79 27.9331 100.383 27.3085 99.3642 26.243C98.3454 25.1775 97.7978 23.7581 97.8414 22.2961V16.8315C97.8414 14.9356 96.97 13.7214 95.2323 13.7214C93.4207 13.7214 92.4053 15.0484 92.4053 17.2864V27.9799C90.919 27.9331 89.5122 27.3085 88.4934 26.243C87.4746 25.1775 86.9269 23.7581 86.9705 22.2961V9.01369H92.4053V10.7579C92.945 9.99774 93.6762 9.38846 94.5273 8.98978C95.3784 8.5911 96.3202 8.41669 97.2604 8.48364C98.2072 8.44599 99.1468 8.65861 99.9817 9.09936C100.816 9.54012 101.516 10.1929 102.007 10.9898C102.582 10.1553 103.371 9.48439 104.293 9.04448C105.215 8.60457 106.239 8.41115 107.261 8.48364H107.266ZM117.952 22.3074V9.04H123.386V28C121.9 27.9532 120.493 27.3286 119.474 26.2631C118.455 25.1976 117.907 23.7782 117.951 22.3161L117.952 22.3074ZM27.3599 15.9932H35.1503C34.9798 15.1249 34.4989 14.3454 33.7945 13.7958C33.0901 13.2462 32.2089 12.9628 31.3105 12.9972C30.3943 12.9385 29.4879 13.2104 28.7609 13.7619C28.0339 14.3134 27.5362 15.1067 27.3612 15.9932H27.3599ZM77.9597 8.46735H83.3957V27.4299H77.9584V25.648C77.3011 26.4174 76.4716 27.0266 75.5349 27.4279C74.5982 27.8292 73.5797 28.0117 72.5593 27.9612C67.8125 27.9612 63.8963 23.5968 63.8963 17.948C63.8963 12.2992 67.8086 7.93606 72.5593 7.93606C73.5798 7.88517 74.5983 8.06755 75.5351 8.46889C76.4718 8.87022 77.3013 9.4796 77.9584 10.2492V8.46735H77.9597ZM73.6689 22.5918C74.2712 22.5991 74.8682 22.4813 75.421 22.2462C75.9738 22.011 76.4699 21.6638 76.8769 21.2271C77.2839 20.7905 77.5927 20.2743 77.783 19.7123C77.9733 19.1502 78.0409 18.555 77.9813 17.9655C78.0409 17.376 77.9733 16.7808 77.783 16.2188C77.5927 15.6567 77.2839 15.1405 76.8769 14.7039C76.4699 14.2673 75.9738 13.92 75.421 13.6849C74.8682 13.4497 74.2712 13.3319 73.6689 13.3392C73.0667 13.3319 72.4697 13.4497 71.9169 13.6849C71.3641 13.92 70.868 14.2673 70.461 14.7039C70.0539 15.1405 69.7452 15.6567 69.5549 16.2188C69.3646 16.7808 69.297 17.376 69.3565 17.9655C69.297 18.555 69.3646 19.1502 69.5549 19.7123C69.7452 20.2743 70.0539 20.7905 70.461 21.2271C70.868 21.6638 71.3641 22.011 71.9169 22.2462C72.4697 22.4813 73.0667 22.5991 73.6689 22.5918ZM121.105 6.81582C120.216 6.7793 119.377 6.40154 118.767 5.7635C118.157 5.12545 117.826 4.2779 117.844 3.4025C117.819 2.98122 117.878 2.55917 118.019 2.16043C118.159 1.7617 118.378 1.39411 118.663 1.07865C118.948 0.763188 119.293 0.506045 119.68 0.321904C120.066 0.137764 120.485 0.0302366 120.913 0.00546159C121.778 -0.0441755 122.627 0.246091 123.274 0.812417C123.922 1.37874 124.314 2.17474 124.364 3.02533C124.371 3.15055 124.371 3.27603 124.364 3.40124C124.382 4.27665 124.051 5.1242 123.441 5.76224C122.832 6.40029 121.992 6.77805 121.103 6.81457L121.105 6.81582ZM136.54 27.9774C131.032 27.9774 126.938 23.613 126.938 17.9643C126.938 12.3155 131.032 7.95109 136.54 7.95109C138.225 7.94903 139.879 8.40033 141.322 9.25617C142.766 10.112 143.944 11.3398 144.729 12.8067L139.982 15.6887C139.676 15.032 139.178 14.4792 138.553 14.1001C137.928 13.721 137.202 13.5326 136.468 13.5585C135.926 13.5608 135.39 13.6681 134.89 13.8743C134.39 14.0804 133.936 14.3814 133.555 14.76C133.173 15.1387 132.871 15.5875 132.666 16.081C132.461 16.5744 132.356 17.1028 132.358 17.636C132.358 17.7437 132.358 17.8515 132.374 17.958C132.328 18.4894 132.39 19.0244 132.554 19.5325C132.719 20.0405 132.984 20.5117 133.334 20.919C133.684 21.3263 134.112 21.6617 134.594 21.9062C135.076 22.1507 135.602 22.2993 136.142 22.3437C136.249 22.3537 136.359 22.3575 136.468 22.3587C137.202 22.3885 137.928 22.2025 138.554 21.8244C139.18 21.4463 139.677 20.8933 139.982 20.2361L144.729 23.078C143.954 24.5556 142.779 25.794 141.334 26.6563C139.889 27.5187 138.23 27.9716 136.54 27.9649V27.9774ZM152.082 14.0209C152.082 16.1824 161 14.7414 161 21.7573C161 26.1217 157.376 27.9774 153.467 27.9774C149.843 27.9774 147.089 26.5364 145.677 23.4664L150.39 20.6596C150.558 21.3257 150.957 21.9133 151.518 22.3208C152.079 22.7283 152.768 22.9301 153.464 22.8913C154.769 22.8913 155.425 22.474 155.425 21.7159C155.425 19.6308 146.507 20.7298 146.507 14.1688C146.507 10.0337 149.841 7.94859 153.61 7.94859C155.053 7.91847 156.478 8.28177 157.725 8.99829C158.972 9.7148 159.993 10.7566 160.675 12.0085L156.037 14.6261C155.849 14.1402 155.517 13.7212 155.084 13.4235C154.651 13.1258 154.137 12.9632 153.608 12.9571C152.667 12.9571 152.087 13.333 152.087 14.0184L152.082 14.0209Z"
          style="fill: #000"
        />
      </svg>
      <img
        src="../../../../assets/img/paid_logo.svg"
        alt=""
        *ngIf="isWhiteLabel && !isWellblum"
        style="height: 30px; margin-bottom: 20px"
      />
      <img
        src="../../../../assets/img/wellblum_logo.svg"
        alt=""
        *ngIf="isWhiteLabel && isWellblum"
        style="height: 30px; margin-bottom: 20px"
      />
    </div>

    <form
      class="session_wrapper_2-content"
      *ngIf="!resetPasswordBool && !twoFactorBool"
    >
      <div class="session_wrapper_2-header">
        <div
          class="session_wrapper_2-header-icon"
          [ngStyle]="{ 'border-radius': isWhiteLabel ? '0px' : '10px' }"
        >
          <img
            src="../../../../assets/img/login_logo_v2.svg"
            alt=""
            *ngIf="!isWhiteLabel"
          />
          <img
            src="../../../../assets/img/paid_icon.svg"
            alt=""
            *ngIf="isWhiteLabel && !isWellblum"
          />
          <img
            src="../../../../assets/img/wellblum_icon.png"
            alt=""
            *ngIf="isWhiteLabel && isWellblum"
          />
        </div>
        <div class="session_wrapper_2-header-text">
          <h1 *ngIf="!isWhiteLabel">Welcome to Behamics</h1>
          <h1 *ngIf="isWhiteLabel && !isWellblum">Welcome to Paid</h1>
          <h1 *ngIf="isWhiteLabel && isWellblum">Welcome to Wellblum</h1>
        </div>
      </div>
      <div class="session_wrapper_2-body" *ngIf="!isWhiteLabel">
        <button
          class="login-with_email-button"
          mat-button
          (click)="loginWithMicrosoft($event)"
        >
          <svg
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
          >
            <path fill="#F35325" d="M1 1h6.5v6.5H1V1z" />
            <path fill="#81BC06" d="M8.5 1H15v6.5H8.5V1z" />
            <path fill="#05A6F0" d="M1 8.5h6.5V15H1V8.5z" />
            <path fill="#FFBA08" d="M8.5 8.5H15V15H8.5V8.5z" />
          </svg>
          <span> Continue with Microsoft Account </span>
        </button>
      </div>
    </form>
    <form
      class="session_wrapper_2-content"
      [formGroup]="form"
      (ngSubmit)="login()"
      *ngIf="!resetPasswordBool && !twoFactorBool"
    >
      <div class="session_wrapper_2-body">
        <div class="session_wrapper_2-body-or" *ngIf="!isWhiteLabel">
          <p>or</p>
        </div>
        <div class="session_wrapper_2-body-inputs-container show-inputs">
          <div class="session_wrapper_2-input">
            <label for="email">E-Mail</label>
            <input
              id="email"
              class="email-input"
              placeholder="name@company.com"
              type="email"
              name="email"
              formControlName="email"
            />
          </div>
          <div class="session_wrapper_2-input">
            <label for="password">Password</label>
            <input
              id="password"
              placeholder="Enter your Password"
              [type]="showPassword ? 'text' : 'password'"
              name="password"
              required
              formControlName="password"
            />
            <div
              class="input_eye_icon"
              [ngClass]="{ show: showPassword }"
              (click)="toogleShowPassword()"
            ></div>
          </div>
        </div>
        <button
          class="login-with_email-button"
          mat-button
          [disabled]="loginLoading"
        >
          <span> Sign in </span>

          <svg *ngIf="loginLoading" class="spinner" viewBox="0 0 66 66">
            <circle
              class="path"
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
            ></circle>
          </svg>
        </button>
        <p class="error-login-message" *ngIf="moreInfo != ''">
          {{ moreInfo }}
        </p>
      </div>
      <div class="session_wrapper_2-footer">
        <p class="session_wrapper_2-has-account">
          <span (click)="resetPasswordFunc(true)">Unable to log in?</span>
        </p>
      </div>
    </form>

    <form
      [formGroup]="twoFactorForm"
      (ngSubmit)="submitTwoFactorCode()"
      *ngIf="twoFactorBool"
      class="session_wrapper_2-content"
    >
      <div class="session_wrapper_2-header">
        <div class="session_wrapper_2-header-text">
          <h1>Two-Step Verification</h1>
          <p>
            We've sent a code to your email. Please enter it below to proceed.
          </p>
        </div>
      </div>
      <div class="session_wrapper_2-body">
        <div class="session_wrapper_2-body-inputs-container show-inputs">
          <div class="session_wrapper_2-input">
            <label for="2facode">2FA Code</label>
            <input
              id="2facode"
              placeholder="Enter the 2FA Code"
              type="text"
              name="twoFARequired"
              formControlName="twoFARequired"
            />
          </div>
        </div>
        <button
          class="login-with_email-button"
          mat-button
          [disabled]="twoFactorForm.invalid"
        >
          <span> Submit </span>

          <svg *ngIf="loginLoading" class="spinner" viewBox="0 0 66 66">
            <circle
              class="path"
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
            ></circle>
          </svg>
        </button>
      </div>
      <div class="session_wrapper_2-footer">
        <p class="session_wrapper_2-has-account">
          <span (click)="resetPasswordFunc(false)">Back to Login Page</span>
        </p>
        <p
          class="error-login-message"
          *ngIf="moreInfo != ''"
          style="color: red"
        >
          {{ moreInfo }}
        </p>
      </div>
    </form>

    <form
      [formGroup]="resetPasswordForm"
      (ngSubmit)="resetRequest()"
      *ngIf="resetPasswordBool"
      class="session_wrapper_2-content"
    >
      <div class="session_wrapper_2-header">
        <div class="session_wrapper_2-header-text">
          <h1>Reset your password</h1>
          <p>
            {{ resetPasswordStatus }}
          </p>
        </div>
      </div>

      <div class="session_wrapper_2-body">
        <div class="session_wrapper_2-body-inputs-container show-inputs">
          <div class="session_wrapper_2-input">
            <label for="email">E-Mail</label>
            <input
              class="email-input"
              placeholder="E-Mail"
              type="email"
              name="email"
              formControlName="email"
              [attr.disabled]="resetPasswordFinished"
            />
          </div>
        </div>
        <button
          class="login-with_email-button"
          mat-button
          [disabled]="resetPasswordFinished"
        >
          <span> {{ forgotStatus }} </span>
          <svg *ngIf="loginLoading" class="spinner" viewBox="0 0 66 66">
            <circle
              class="path"
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
            ></circle>
          </svg>
        </button>
      </div>

      <div class="session_wrapper_2-footer">
        <p class="session_wrapper_2-has-account">
          <span (click)="resetPasswordFunc(false)">Back to Login Page</span>
        </p>
      </div>
    </form>
  </div>
  <div class="session_wrapper_2-right_container"></div>
</div>

<!-- <div class="session_wrapper signin main_login">
  <div class="session_wrapper-left_container">
    <div class="session_wrapper-left_container-header">
      <div class="behamics-logo">
        <svg
          viewBox="0 0 161 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.8339 7.95235C15.5807 7.95235 19.4969 12.3167 19.4969 17.9655C19.4969 23.6143 15.5846 27.9787 10.8339 27.9787C9.81249 28.0297 8.79296 27.8474 7.85515 27.4461C6.91735 27.0448 6.08675 26.4354 5.42841 25.6656V27.4474H0V0.895131C1.48589 0.943557 2.89166 1.56942 3.90921 2.63555C4.92675 3.70169 5.47306 5.12112 5.42841 6.58275V10.2605C6.08564 9.49102 6.91513 8.88175 7.85186 8.48043C8.78859 8.07911 9.80709 7.89664 10.8275 7.94733L10.8339 7.95235ZM9.74846 22.5918C10.3507 22.5991 10.9477 22.4813 11.5005 22.2462C12.0533 22.011 12.5494 21.6638 12.9564 21.2271C13.3635 20.7905 13.6722 20.2743 13.8625 19.7123C14.0528 19.1502 14.1204 18.555 14.0609 17.9655C14.1206 17.3759 14.0532 16.7806 13.863 16.2184C13.6727 15.6562 13.364 15.1398 12.957 14.7031C12.5499 14.2663 12.0537 13.9189 11.5008 13.6837C10.948 13.4485 10.3508 13.3307 9.74846 13.338C9.14547 13.3296 8.54748 13.4466 7.99368 13.6814C7.43987 13.9161 6.94274 14.2633 6.53487 14.7002C6.127 15.1371 5.81758 15.6539 5.62691 16.2166C5.43623 16.7793 5.36859 17.3753 5.42841 17.9655C5.36878 18.5556 5.43656 19.1515 5.62733 19.7141C5.81809 20.2766 6.12753 20.7932 6.53539 21.23C6.94324 21.6667 7.4403 22.0138 7.99401 22.2485C8.54772 22.4832 9.14559 22.6002 9.74846 22.5918ZM27.4682 20.2411C27.7791 21.1032 28.3789 21.8358 29.1691 22.3183C29.9592 22.8008 30.8928 23.0047 31.8163 22.8963C32.4668 22.9125 33.1133 22.7924 33.7129 22.544C34.3126 22.2955 34.8516 21.9244 35.2942 21.4553L39.6423 24.0767C38.7784 25.341 37.5976 26.3648 36.214 27.0492C34.8304 27.7336 33.2907 28.0555 31.7437 27.9837C25.5521 27.9837 21.706 23.6193 21.706 17.9705C21.706 12.3218 25.6158 7.95736 31.3449 7.95736C36.6345 7.95736 40.5481 12.2428 40.5481 17.9705C40.5533 18.7324 40.482 19.493 40.3354 20.2411H27.4682ZM53.8395 8.45607C57.5009 8.45607 60.6158 11.1852 60.6158 16.3065V27.9524C59.1294 27.9056 57.7226 27.2809 56.7038 26.2154C55.685 25.15 55.1374 23.7306 55.181 22.2685V17.1435C55.2417 16.7061 55.2048 16.2608 55.0729 15.8388C54.9409 15.4168 54.7172 15.0281 54.4171 14.6997C54.1171 14.3713 53.7479 14.1111 53.3354 13.9372C52.9228 13.7633 52.4766 13.6798 52.0279 13.6926C50.0354 13.6926 48.6582 14.9106 48.6582 17.5996V27.9524C47.1719 27.9056 45.7651 27.2809 44.7463 26.2154C43.7275 25.15 43.1799 23.7306 43.2235 22.2685V1.40512C44.7097 1.45226 46.1163 2.077 47.135 3.14242C48.1537 4.20784 48.7015 5.62704 48.6582 7.08899V10.7667C49.2624 9.99252 50.0512 9.37668 50.9549 8.97367C51.8586 8.57066 52.8493 8.39288 53.8395 8.45607ZM107.266 8.48364C111.433 8.48364 114.146 11.5937 114.146 16.334V27.9799C112.659 27.9331 111.253 27.3085 110.234 26.243C109.215 25.1775 108.667 23.7581 108.711 22.2961V16.8315C108.711 14.9356 107.841 13.7214 106.102 13.7214C104.29 13.7214 103.276 15.0484 103.276 17.2864V27.9799C101.79 27.9331 100.383 27.3085 99.3642 26.243C98.3454 25.1775 97.7978 23.7581 97.8414 22.2961V16.8315C97.8414 14.9356 96.97 13.7214 95.2323 13.7214C93.4207 13.7214 92.4053 15.0484 92.4053 17.2864V27.9799C90.919 27.9331 89.5122 27.3085 88.4934 26.243C87.4746 25.1775 86.9269 23.7581 86.9705 22.2961V9.01369H92.4053V10.7579C92.945 9.99774 93.6762 9.38846 94.5273 8.98978C95.3784 8.5911 96.3202 8.41669 97.2604 8.48364C98.2072 8.44599 99.1468 8.65861 99.9817 9.09936C100.816 9.54012 101.516 10.1929 102.007 10.9898C102.582 10.1553 103.371 9.48439 104.293 9.04448C105.215 8.60457 106.239 8.41115 107.261 8.48364H107.266ZM117.952 22.3074V9.04H123.386V28C121.9 27.9532 120.493 27.3286 119.474 26.2631C118.455 25.1976 117.907 23.7782 117.951 22.3161L117.952 22.3074ZM27.3599 15.9932H35.1503C34.9798 15.1249 34.4989 14.3454 33.7945 13.7958C33.0901 13.2462 32.2089 12.9628 31.3105 12.9972C30.3943 12.9385 29.4879 13.2104 28.7609 13.7619C28.0339 14.3134 27.5362 15.1067 27.3612 15.9932H27.3599ZM77.9597 8.46735H83.3957V27.4299H77.9584V25.648C77.3011 26.4174 76.4716 27.0266 75.5349 27.4279C74.5982 27.8292 73.5797 28.0117 72.5593 27.9612C67.8125 27.9612 63.8963 23.5968 63.8963 17.948C63.8963 12.2992 67.8086 7.93606 72.5593 7.93606C73.5798 7.88517 74.5983 8.06755 75.5351 8.46889C76.4718 8.87022 77.3013 9.4796 77.9584 10.2492V8.46735H77.9597ZM73.6689 22.5918C74.2712 22.5991 74.8682 22.4813 75.421 22.2462C75.9738 22.011 76.4699 21.6638 76.8769 21.2271C77.2839 20.7905 77.5927 20.2743 77.783 19.7123C77.9733 19.1502 78.0409 18.555 77.9813 17.9655C78.0409 17.376 77.9733 16.7808 77.783 16.2188C77.5927 15.6567 77.2839 15.1405 76.8769 14.7039C76.4699 14.2673 75.9738 13.92 75.421 13.6849C74.8682 13.4497 74.2712 13.3319 73.6689 13.3392C73.0667 13.3319 72.4697 13.4497 71.9169 13.6849C71.3641 13.92 70.868 14.2673 70.461 14.7039C70.0539 15.1405 69.7452 15.6567 69.5549 16.2188C69.3646 16.7808 69.297 17.376 69.3565 17.9655C69.297 18.555 69.3646 19.1502 69.5549 19.7123C69.7452 20.2743 70.0539 20.7905 70.461 21.2271C70.868 21.6638 71.3641 22.011 71.9169 22.2462C72.4697 22.4813 73.0667 22.5991 73.6689 22.5918ZM121.105 6.81582C120.216 6.7793 119.377 6.40154 118.767 5.7635C118.157 5.12545 117.826 4.2779 117.844 3.4025C117.819 2.98122 117.878 2.55917 118.019 2.16043C118.159 1.7617 118.378 1.39411 118.663 1.07865C118.948 0.763188 119.293 0.506045 119.68 0.321904C120.066 0.137764 120.485 0.0302366 120.913 0.00546159C121.778 -0.0441755 122.627 0.246091 123.274 0.812417C123.922 1.37874 124.314 2.17474 124.364 3.02533C124.371 3.15055 124.371 3.27603 124.364 3.40124C124.382 4.27665 124.051 5.1242 123.441 5.76224C122.832 6.40029 121.992 6.77805 121.103 6.81457L121.105 6.81582ZM136.54 27.9774C131.032 27.9774 126.938 23.613 126.938 17.9643C126.938 12.3155 131.032 7.95109 136.54 7.95109C138.225 7.94903 139.879 8.40033 141.322 9.25617C142.766 10.112 143.944 11.3398 144.729 12.8067L139.982 15.6887C139.676 15.032 139.178 14.4792 138.553 14.1001C137.928 13.721 137.202 13.5326 136.468 13.5585C135.926 13.5608 135.39 13.6681 134.89 13.8743C134.39 14.0804 133.936 14.3814 133.555 14.76C133.173 15.1387 132.871 15.5875 132.666 16.081C132.461 16.5744 132.356 17.1028 132.358 17.636C132.358 17.7437 132.358 17.8515 132.374 17.958C132.328 18.4894 132.39 19.0244 132.554 19.5325C132.719 20.0405 132.984 20.5117 133.334 20.919C133.684 21.3263 134.112 21.6617 134.594 21.9062C135.076 22.1507 135.602 22.2993 136.142 22.3437C136.249 22.3537 136.359 22.3575 136.468 22.3587C137.202 22.3885 137.928 22.2025 138.554 21.8244C139.18 21.4463 139.677 20.8933 139.982 20.2361L144.729 23.078C143.954 24.5556 142.779 25.794 141.334 26.6563C139.889 27.5187 138.23 27.9716 136.54 27.9649V27.9774ZM152.082 14.0209C152.082 16.1824 161 14.7414 161 21.7573C161 26.1217 157.376 27.9774 153.467 27.9774C149.843 27.9774 147.089 26.5364 145.677 23.4664L150.39 20.6596C150.558 21.3257 150.957 21.9133 151.518 22.3208C152.079 22.7283 152.768 22.9301 153.464 22.8913C154.769 22.8913 155.425 22.474 155.425 21.7159C155.425 19.6308 146.507 20.7298 146.507 14.1688C146.507 10.0337 149.841 7.94859 153.61 7.94859C155.053 7.91847 156.478 8.28177 157.725 8.99829C158.972 9.7148 159.993 10.7566 160.675 12.0085L156.037 14.6261C155.849 14.1402 155.517 13.7212 155.084 13.4235C154.651 13.1258 154.137 12.9632 153.608 12.9571C152.667 12.9571 152.087 13.333 152.087 14.0184L152.082 14.0209Z"
            style="fill: #000"
          />
        </svg>
      </div>
    </div>

    <div class="session_wrapper-left_container-form_container">
      <form
        [formGroup]="form"
        (ngSubmit)="login()"
        *ngIf="!resetPasswordBool && !twoFactorBool"
      >
        <div class="session_wrapper-left_container-form_content">
          <h1>Welcome to Behamics</h1>
          <mat-form-field>
            <input
              class="email-input"
              matInput
              placeholder="E-Mail"
              type="email"
              name="email"
              formControlName="email"
            />
          </mat-form-field>
          <mat-form-field>
            <input
              matInput
              placeholder="Password"
              [type]="showPassword ? 'text' : 'password'"
              name="password"
              required
              formControlName="password"
            />
            <div
              class="input_eye_icon"
              [ngClass]="{ show: showPassword }"
              (click)="toogleShowPassword()"
            ></div>
          </mat-form-field>
          <div
            class="left_container-form_content-unable left_container-form_content-no_account"
          >
            <div class="checkbox_container">
              <mat-checkbox> Remember me </mat-checkbox>
            </div>
            <span (click)="resetPasswordFunc(true)">Unable to log in?</span>
          </div>
          <button
            class="mat-blue"
            mat-button
            [disabled]="form.invalid && form.touched"
          >
            {{ logStatus }}
            <svg
              *ngIf="loginLoading"
              class="spinner"
              width="12px"
              height="12px"
              viewBox="0 0 66 66"
            >
              <circle
                class="path"
                fill="none"
                stroke-width="6"
                stroke-linecap="round"
                cx="33"
                cy="33"
                r="30"
              ></circle>
            </svg>
          </button>
          <div class="session_wrapper-button-container">
            <div class="login-with_email-divider">
              <p class="login-with_email-text">OR</p>
            </div>
            <button
              class="login-with_email-button"
              mat-button
              (click)="loginWithMicrosoft($event)"
            >
              <svg
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
              >
                <path fill="#F35325" d="M1 1h6.5v6.5H1V1z" />
                <path fill="#81BC06" d="M8.5 1H15v6.5H8.5V1z" />
                <path fill="#05A6F0" d="M1 8.5h6.5V15H1V8.5z" />
                <path fill="#FFBA08" d="M8.5 8.5H15V15H8.5V8.5z" />
              </svg>
              <span> Continue with Microsoft Account </span>
            </button>
          </div>
          <p
            class="text-center error-login-message"
            *ngIf="moreInfo != ''"
            style="color: red"
          >
            {{ moreInfo }}
          </p>
        </div>
      </form>

      <form
        [formGroup]="resetPasswordForm"
        (ngSubmit)="resetRequest()"
        *ngIf="resetPasswordBool"
      >
        <div class="session_wrapper-left_container-form_content">
          <h1 style="width: 100%; margin-bottom: 30px">Reset your password</h1>
          <div style="margin-bottom: 30px">
            {{ resetPasswordStatus }}
          </div>
          <mat-form-field>
            <input
              class="email-input"
              matInput
              placeholder="E-Mail"
              type="email"
              name="email"
              formControlName="email"
              [attr.disabled]="resetPasswordFinished"
            />
          </mat-form-field>
          <button
            class="mat-blue"
            mat-button
            [disabled]="resetPasswordFinished"
          >
            {{ forgotStatus }}
            <svg
              *ngIf="loginLoading"
              class="spinner"
              width="12px"
              height="12px"
              viewBox="0 0 66 66"
            >
              <circle
                class="path"
                fill="none"
                stroke-width="6"
                stroke-linecap="round"
                cx="33"
                cy="33"
                r="30"
              ></circle>
            </svg>
          </button>
          <div class="left_container-form_content-no_account">
            <span (click)="resetPasswordFunc(false)">Back to Login Page</span>
          </div>
        </div>
      </form>

      <form
        [formGroup]="twoFactorForm"
        (ngSubmit)="submitTwoFactorCode()"
        *ngIf="twoFactorBool"
      >
        <div class="session_wrapper-left_container-form_content">
          <h1 style="width: 100%; margin-bottom: 30px">
            Two-Step Verification
          </h1>
          <h3 style="font-size: 14px; font-weight: 400">
            We've sent a code to your email. Please enter it below to proceed.
          </h3>
          <mat-form-field>
            <input
              matInput
              placeholder="Enter the 2FA Code"
              type="text"
              name="twoFARequired"
              formControlName="twoFARequired"
            />
          </mat-form-field>
          <button
            class="mat-blue"
            mat-button
            [disabled]="twoFactorForm.invalid"
          >
            Submit
            <svg
              *ngIf="loginLoading"
              class="spinner"
              width="12px"
              height="12px"
              viewBox="0 0 66 66"
            >
              <circle
                class="path"
                fill="none"
                stroke-width="6"
                stroke-linecap="round"
                cx="33"
                cy="33"
                r="30"
              ></circle>
            </svg>
          </button>
          <p
            class="text-center error-login-message"
            *ngIf="moreInfo != ''"
            style="color: red"
          >
            {{ moreInfo }}
          </p>
          <div class="left_container-form_content-no_account">
            <span (click)="resetPasswordFunc(false)">Back to Login Page</span>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="session_wrapper-right_container"></div>
</div> -->
